import * as React from 'react'
import TimelineList from 'components/TimelineList'
import TimelineListItem from 'components/TimelineList/TimelineListItem'
import { moment } from 'features/Moment'
import { orderBy } from 'lodash'

export interface IContactMessagesTimelineProps {
  messages: {
    id: string
    dateSent: string
    number: string
    otherNumber: string
    serviceId: string
  }[]
}

export class ContactMessagesTimeline extends React.Component<IContactMessagesTimelineProps> {
  render() {
    const { messages } = this.props
    return (
      <TimelineList title="Recent SMS Messages">
        {messages &&
          orderBy(messages, ['dateSent'], ['desc'])
            .slice(0, 25)
            .map((item, idx) => {
              return (
                <TimelineListItem
                  key={idx}
                  to={`/dashboard/messages/${item.serviceId}/${item.otherNumber}`}
                >
                  {item.number} - {moment(item.dateSent).fromNow()}
                </TimelineListItem>
              )
            })}
        {(!messages || messages.length === 0) && (
          <TimelineListItem>No SMS messages have been sent</TimelineListItem>
        )}
      </TimelineList>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactMessagesTimeline/ContactMessagesTimeline.tsx